const QUALITY = 90;
const PHONE_QUALITY = 75;
const PHONE_MAX_WIDTH = 1200;

const CACHE_VERSION = 1;

const RASTER_TO_CONVERT = /\.(jpe?g|png)(\?|#|$)/i;
const WEBP = /\.webp(\?|#|$)/i;

function filterFor(src: string, width: number): string {
  const source = src.split("/m/")[0];
  const phoneSized = width <= PHONE_MAX_WIDTH;
  if (RASTER_TO_CONVERT.test(source)) {
    return `format(webp):quality(${phoneSized ? PHONE_QUALITY : QUALITY})`;
  }
  if (phoneSized && WEBP.test(source)) return `format(webp):quality(${PHONE_QUALITY})`;
  return "format(webp)";
}

function bust(filters: string, filter: string): string {
  return filters + `:${filter}`.repeat(CACHE_VERSION);
}

const CROP = /\/m\/(\d+)x(\d+)(\/filters:[^/]+)?$/;

const NATURAL = /\/f\/\d+\/(\d+)x/;

export function storyblokImage(src: string, width: number): string {
  if (!src) return src;

  if (src.includes("googleusercontent.com")) {
    return /=s\d+/.test(src) ? src.replace(/=s\d+/, `=s${width}`) : `${src}=s${width}`;
  }

  if (!src.includes("a.storyblok.com")) return src;
  if (/\.svg(\?|#|$)/i.test(src)) return `${src}?v=${CACHE_VERSION}#w${width}`;

  const natural = src.match(NATURAL);
  const w = natural ? Math.min(width, Number(natural[1])) : width;

  const filter = filterFor(src, w);
  const crop = src.match(CROP);
  if (crop) {
    const [full, cw, ch, filters = `/filters:${filter}`] = crop;
    const height = Math.round(w * (Number(ch) / Number(cw)));
    const base = src.slice(0, src.length - full.length);
    return `${base}/m/${w}x${height}${bust(filters, filter)}`;
  }

  return `${src}/m/${w}x0/${bust(`filters:${filter}`, filter)}`;
}

export default function storyblokImageLoader({
  src,
  width,
}: {
  src: string;
  width: number;
  quality?: number;
}): string {
  return storyblokImage(src, width);
}
